export default class LoginRequest {
  username: string;
  password: string;

  constructor(
    arg1: string | { username: string; password: string },
    arg2?: string
  ) {
    if (typeof arg1 === "string") {
      this.username = arg1;
      this.password = arg2 ?? "";
    } else {
      this.username = arg1.username;
      this.password = arg1.password;
    }
  }

  get _username(): string {
    return this.username;
  }

  set _username(value: string) {
    if (!value) throw new Error("Username cannot be empty");
    this.username = value;
  }

  get _password(): string {
    return this.password;
  }

  set _password(value: string) {
    if (value.length < 3) throw new Error("Password too short");
    this.password = value;
  }

  // 👇 convert class instance to plain object
  toJSON() {
    return {
      username: this.username,
      password: this.password,
    };
  }
}
